import type { AxiosResponse } from 'axios';

export const parseFilename = (headers: AxiosResponse['headers']): string | null => {
  const header = headers['content-disposition'];

  if (header === '' || header === undefined) {
    return null;
  }

  const re = /filename="(.*)"/gm;
  // strip header directive, unquote
  const results = re.exec(header);
  if (results === null || results.length < 2) {
    return null;
  }

  return results[1];
};
